<template>
  <v-navigation-drawer
    v-model="drawer"
    clipped
    app
    :mobile-breakpoint="$route.query.event ? '1904' : '1360'"
    class="colorDominant grey darken-3 colorMenuLeftTheme"
  >
    <v-progress-linear
      v-if="$vuetify.breakpoint.xsOnly"
      absolute
      indeterminate
      :active="loading"
    >
    </v-progress-linear>

    <ButtonLanguages v-if="$vuetify.breakpoint.xsOnly" class="pa-2" />
    <v-divider></v-divider>

    <div class="pa-2">
      <Search />
    </div>

    <v-divider></v-divider>

    <!-- Links: HOME and LIVE -->
    <v-list dense nav>
      <v-list-item
        :to="{
          name: $permissions().bigTable ? 'bigTable' : 'Sports',
          query: { sport: nameSport, live: nameSport },
        }"
        v-on:click="getEvents('', '', innerSport)"
      >
        <v-list-item-icon>
          <v-icon>mdi-home-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <!-- <v-list-item-title v-text="innerSport"></v-list-item-title> -->
          <v-list-item-title v-text="$t('homeAgent')"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'live', query: { live: nameSport } }">
        <v-list-item-icon>
          <v-icon color="primary" class="live-ani">mdi-access-point</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$t('live')"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- Favorites -->
      <v-list-item
        :disabled="getFavoritesList.length == 0"
        :input-value="this.$route.name === 'favorites'"
        @click="toRouteFavorite()"
      >
        <v-list-item-icon>
          <v-icon>mdi-star</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$t('favorites')"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <v-chip small color="rgba(255,255,255,.12)">{{
            getFavoritesList.length
          }}</v-chip>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
    <!-- / Links: HOME and LIVE -->

    <v-divider></v-divider>

    <!-- Links: SPORTS -->
    <!-- <v-list dense nav>
      <v-list-item
        exact
        v-for="sport in sports"
        :key="`menu-sport-${sport.id}`"
        :to="{
          name: $permissions().bigTable ? 'bigTable' : 'Sports',
          query: { sport: nameSport, live: nameSport },
        }"
        v-on:click="getEvents('', '', sport.id)"
      >
        <v-list-item-icon>
          <v-icon>{{ iconT(sport.id) }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="`${sport.name}`"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider> -->

    <!-- ALL SPORTS -->
    <v-list dense nav>
      <v-subheader class="overline">{{ $t("allSports") }} </v-subheader>
      <v-list-group
        v-for="sport in sports"
        :key="`sport-${sport.id}`"
        v-model="sport.active"
        append-icon="mdi-menu-down"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <template v-if="sport.icon_img">
              <img class="mb-0" width="24px" :src="sport.icon_img" />
            </template>
            <v-icon v-else-if="!iconT(sport.id).custom">
              {{ iconT(sport.id).src }}
            </v-icon>
            <v-img
              v-else
              :src="iconT(sport.id).src"
              width="24"
              height="24"
              :style="sport.active ? filter : ''"
            ></v-img>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ sport.name }} &nbsp;
              <v-chip x-small color="rgba(255,255,255,.12)">{{
                sport.total_events
              }}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-group
          v-for="category in sport.categories"
          :key="`category-${category.id}`"
          v-model="category.active"
          sub-group
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="category.name"></v-list-item-title>
            </v-list-item-content>
          </template>

          <!-- todos -->
          <v-list-item
            class="pl-3"
            :to="{
              name: 'category',
              params: { sport: sport.id, category: category.id },
              query: {
                sport: sport.name,
                category: category.name,
              },
              hash: $vuetify.breakpoint.smAndDown ? '#scrollTop' : '',
            }"
          >
            <v-list-item-content>
              <v-list-item-title>
                <span class="d-block text-truncate" style="max-width: 150px">
                  {{ $t("all") }} {{ category.name }}</span
                >
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-chip small color="rgba(255,255,255,.12)">{{
                category.total_by_category
              }}</v-chip>
            </v-list-item-icon>
          </v-list-item>
          <!-- / todos -->

          <!-- item -->
          <!-- v-on:click="filterByTournament(category, tournament, sport.id)" -->
          <v-list-item
            class="pl-3"
            v-for="tournament in category.tournaments"
            :key="`tournament-${tournament.id}`"
            :to="{
              name: 'tournament',
              params: {
                sport: sport.id,
                category: category.id,
                tournament: tournament.id,
              },
              query: {
                sport: sport.name,
                category: category.name,
                tournament: tournament.name,
              },
              hash: $vuetify.breakpoint.smAndDown ? '#scrollTop' : '',
            }"
          >
            <v-list-item-content>
              <v-list-item-title>
                <span class="d-block text-truncate" style="max-width: 150px">{{
                  tournament.name
                }}</span>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-chip
                small
                v-text="tournament.qtd_events"
                color="rgba(255,255,255,.12)"
              ></v-chip>
            </v-list-item-icon>
          </v-list-item>
          <!-- / item -->
        </v-list-group>
      </v-list-group>
    </v-list>
    <v-divider></v-divider>
    <v-subheader class="overline mt-4">{{ $t("consultBet") }}</v-subheader>
    <div class="mx-3" style="padding-bottom: 100px">
      <v-form v-model="valid" ref="formConsultBet" lazy-validation>
        <div class="d-flex">
          <v-text-field
            v-model="betNumber"
            clearable
            :label="$t('betCode')"
            solo-inverted
            required
            :rules="[(v) => !!v || '*Campo obrigatório.']"
            flat
            :style="
              $vuetify.breakpoint.mdAndUp
                ? 'max-width:290px'
                : 'padding-top:8px;'
            "
          ></v-text-field>
          <v-btn
            :disabled="!valid"
            type="submit"
            @click.prevent="consultBet"
            fab
            small
            class="ml-1 mt-1"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </div>
      </v-form>
      <DialogConsultBet :data="dataConsultBet" />
    </div>
  </v-navigation-drawer>
</template>

<style lang="css">
.v-application--is-ltr
  .v-list--dense.v-list--nav
  .v-list-group--no-action
  .v-list-group--sub-group
  > .v-list-group__items
  > div
  > .v-list-item {
  padding-left: 16px !important;
}
</style>

<script>
import { icon } from "@/components/icon-sport/icon.js";
import rulesOdds from "@/mixins/rulesOdds";
import DialogConsultBet from "./Dialog";
import ButtonLanguages from "@/components/btn-languages/btn-languages";
import Search from "@/components/search/search";
export default {
  name: "menu-sidebar",
  props: ["drawer_prop"],
  mixins: [rulesOdds],
  components: {
    DialogConsultBet,
    ButtonLanguages,
    Search,
  },
  data() {
    return {
      drawer: null,
      loading: false,
      item: 0,
      sports: [],
      live: [],
      betNumber: "",
      dataConsultBet: [],
      // filtred: {},
      valid: false,
    };
  },
  computed: {
    data_events() {
      return this.$store.state.data_events;
    },
    innerSport() {
      return this.$store.state.innerSport;
    },
    nameSport() {
      return this.$store.getters.getNameSportById("6046");
    },
    getFavoritesList() {
      return this.$store.state.favoriteTournaments;
    },
    filter() {
      return this.$customIconsActive(this.$vuetify.theme.themes.dark.primary);
    },
  },
  mounted() {
    this.getListMenu(this.$store.state.operators.operator_id);
    // Se o Usuário chegar os site atraves de um link de conferência:
    if (this.$route.query.conf) {
      this.betNumber = this.$route.query.conf;
      this.consultBet();
    }
    // this.clone_data_events = this.data_events;
  },
  watch: {
    // Abertura do Drawer(recebendo por prop):
    drawer_prop: function (val) {
      this.drawer = val;
    },
    // Fechamento do Drawer:
    drawer: function (newVal) {
      this.$emit("update:drawer", newVal);
    },
  },
  methods: {
    // doFilter(category, tournament) {
    //   const categoryFiltred = this.data_events.all.filter(
    //     (item) => item.id == category.id
    //   );
    //   this.filtred = { ...categoryFiltred[0] };
    //   if (tournament != "") {
    //     this.filtred.tournaments = this.filtred.tournaments.filter(
    //       (t) => t.id == tournament.id
    //     );
    //   }
    //   this.data_events.filtred = [this.filtred];
    //   this.$store.commit("data_events", this.data_events);
    // },
    // getEvents: function (category, tournament, sport) {
    //   if (this.innerSport === sport) {
    //     const data = JSON.parse(localStorage.data_events);
    //     this.$store.commit("data_events", data);
    //     return;
    //   }
    //   localStorage.setItem("data_events", {});
    //   this.$store.commit("innerSport", sport);
    //   this.loading = true;
    //   const objInner = { id_esporte: sport };
    //   this.$axios
    //     .post("/agent/table/inner", this.$formdata(objInner))
    //     .then(async (resp) => {
    //       const data = resp.data.dados.categories;
    //       await this.editDataSports(data);
    //       const data_events = {
    //         all: data,
    //         filtred: [],
    //       };
    //       await localStorage.setItem(
    //         "data_events",
    //         JSON.stringify(data_events)
    //       );
    //       this.$store.commit("data_events", data_events);
    //     })
    //     .catch((err) => {
    //       if (err.response.status == 400) {
    //         localStorage.setItem(
    //           "data_events",
    //           JSON.stringify({ all: [], filtred: [] })
    //         );
    //         this.$store.commit("data_events", { all: [], filtred: [] });
    //         this.data_events.filtred = [];
    //       }
    //     })
    //     .finally(() => (this.loading = false));
    // },
    // Recupera a Lista de Sports, Categories, Tournaments;
    getListMenu: function (idOperator) {
      this.loading = true;
      this.$axios
        .post(`main/leftMenu?id_operator=${idOperator}`)
        .then((resp) => {
          const { sports } = resp.data;
          this.sports = sports;
          this.putTotalEvents(this.sports);
        })
        .catch(() => {
          const msg = "Algo deu errado. Tente novamente.";
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => (this.loading = false));
    },
    putTotalEvents: function (arr) {
      const listCountrys = new Object();
      const listTournaments = new Object();
      for (const sport of arr) {
        let total = 0;
        for (const categories of sport.categories) {
          let total_by_category = 0;
          listCountrys[categories.id] = categories.name;
          for (const tournaments of categories.tournaments) {
            listTournaments[tournaments.id] = tournaments.name;
            total = total + Number(tournaments.qtd_events);
            total_by_category =
              total_by_category + Number(tournaments.qtd_events);
            this.$set(sport, "total_events", total);
            this.$set(categories, "total_by_category", total_by_category);
            this.$set(sport, "active", false);
            this.$set(categories, "active", false);
          }
        }
      }
      sessionStorage.setItem("listCountrys", JSON.stringify(listCountrys));
      sessionStorage.setItem(
        "listTournaments",
        JSON.stringify(listTournaments)
      );
    },
    consultBet: function () {
      if (!this.$refs.formConsultBet.validate() && !this.$route.query.conf) {
        return;
      }
      this.betNumber;
      this.loading = true;
      let domain = this.$domain();
      this.$axios
        .post(
          `/main/confereceBet`,
          this.$formdata({ domain, id_bet: this.betNumber })
        )
        .then((resp) => {
          this.dataConsultBet = resp.data;
        })
        .catch(() => {
          const msg = "Algo deu errado. Tente novamente.";
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => (this.loading = false));
    },
    // Implementa o Icon correto por Sport
    iconT: function (id) {
      if (!icon(id)) {
        return {};
      }

      const sportIcon = icon(id);

      if (sportIcon.custom) {
        return { custom: true, src: this.getCustomIcon(sportIcon.src) };
      }

      return { custom: false, src: sportIcon };
    },
    getCustomIcon(fileName) {
      return require("@/assets/icons/" + fileName);
    },
    toRouteFavorite: function () {
      this.$router
        .push({
          name: "favorites",
          params: {
            sport: this.getFavoritesList[0].id_sport,
          },
          query: {
            sport: this.getFavoritesList[0].name_sport,
          },
          hash: "#scrollTop",
        })
        .catch(() => {});
    },
  },
};
</script>
